import type { GalleryItem } from "@/components/platform/ProfileShowcase";

const BANNER_MARKER = "__mcg_profile_banner__";

export function getProfileBanner(gallery: GalleryItem[]): string | null {
  return gallery.find((item) => item.caption === BANNER_MARKER)?.url ?? null;
}

export function setProfileBanner(gallery: GalleryItem[], url: string | null): GalleryItem[] {
  const other = gallery.filter((item) => item.caption !== BANNER_MARKER);
  return url ? [{ url, caption: BANNER_MARKER }, ...other] : other;
}

export function showcaseGallery(gallery: GalleryItem[]): GalleryItem[] {
  return gallery.filter((item) => item.caption !== BANNER_MARKER);
}